var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRhombus = function SvgRhombus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.171 5.086.474l5.085 3.697-5.085 3.697L0 4.171z",
    fill: "#B1A38A"
  })));
};

export default SvgRhombus;